import { useParams } from 'react-router-dom'

import { ChatRoom } from '../../components/ChatRoom'

export function ChatRoomPage() {
	const { roomId } = useParams<{ roomId: string }>()

	if (!roomId) {
		return (
			<div className="flex h-full items-center justify-center text-muted-foreground">
				ไม่พบห้องแชท
			</div>
		)
	}

	return <ChatRoom roomId={roomId} />
}
